// src/components/google-one-tap/google-one-tap.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment IdentityAnalyticsInteractionEventFragment on IdentityAnalyticsInteractionEvent {\n    eventName\n    eventVersion\n    payload\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment IdentityAnalyticsOutcomeEventFragment on IdentityAnalyticsOutcomeEvent {\n    eventName\n    eventVersion\n    payload\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  fragment IdentityOneTapSubmitActionFragment on IdentityOneTapSubmitAction {\n    atoActions {\n      ... on IdentityCsrfWidgetAction {\n        inputKeys\n        token\n        type\n      }\n    }\n    nonce\n    context\n    clickStreamAnalytics {\n      ...IdentityAnalyticsInteractionEventFragment\n      ...IdentityAnalyticsOutcomeEventFragment\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  mutation GoogleOneTapSubmit($context: ContextInput!, $submitRequest: IdentitySubmitRequestInput!) {\n    googleOneTapSubmit(context: $context, submitRequest: $submitRequest) {\n      ... on IdentityGoogleOneTapMutationResponse {\n        analytics {\n          ...IdentityAnalyticsOutcomeEventFragment\n        }\n        cmsToken\n        flow\n        scenario\n        success\n        variant\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  fragment IdentityAnalyticsImpressionEventFragment on IdentityAnalyticsImpressionEvent {\n    eventName\n    eventVersion\n    payload\n  }\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  fragment IdentityGoogleOneTapResponseFragment on IdentityGoogleOneTapResponse {\n    analytics {\n      ...IdentityAnalyticsImpressionEventFragment\n      ...IdentityAnalyticsInteractionEventFragment\n    }\n    configuration {\n      clientId\n    }\n    action {\n      ...IdentityOneTapSubmitActionFragment\n    }\n    allowIntelligentTrackingPrevention\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  query GoogleOneTapQuery($context: ContextInput!) {\n    googleOneTap(context: $context) {\n      ...IdentityGoogleOneTapResponseFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
import React4 from "react";
import { useBexApi as useBexApi3 } from "@shared-ui/bex-api-context";
// src/components/google-one-tap/__private/__fragments/google-one-tap-query-component.tsx
import React3 from "react";
import { gql as gql7, useQuery } from "@apollo/client";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
// src/components/google-one-tap/__private/__fragments/identity-google-one-tap-response.tsx
import React2, { useEffect as useEffect3, useState as useState2 } from "react";
import { gql as gql6 } from "@apollo/client";
import { useEgClickstream as useEgClickstream3 } from "@shared-ui/clickstream-analytics-context";
// ../../../../node_modules/.pnpm/@shared-ui+logger-context@0.0.4_react@18.3.1/node_modules/@shared-ui/logger-context/dist/esmodule/logger-context.js
import * as React from "react";
// ../../../../node_modules/.pnpm/@shared-ui+logger-context@0.0.4_react@18.3.1/node_modules/@shared-ui/logger-context/dist/esmodule/components/system-event.js
var SystemEventLevel;
(function(SystemEventLevel2) {
    SystemEventLevel2["CRITICAL"] = "CRITICAL";
    SystemEventLevel2["ERROR"] = "ERROR";
    SystemEventLevel2["WARN"] = "WARN";
    SystemEventLevel2["INFO"] = "INFO";
    SystemEventLevel2["UNKNOWN"] = "UNKNOWN";
})(SystemEventLevel || (SystemEventLevel = {}));
var SystemEvent = /** @class */ function() {
    function SystemEvent2(level, name) {
        this.level = level;
        this.name = name;
    }
    SystemEvent2.prototype.toString = function() {
        return "SystemEvent(level=" + this.level.toString() + " name=" + this.name + ")";
    };
    return SystemEvent2;
}();
// ../../../../node_modules/.pnpm/@shared-ui+logger-context@0.0.4_react@18.3.1/node_modules/@shared-ui/logger-context/dist/esmodule/components/logger.js
var __read = function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var __spread = function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
};
var Logger = /** @class */ function() {
    function Logger2(logger) {
        var _this = this;
        this.event = logger.event || function() {};
        var logAtLevel = function logAtLevel(level, message) {
            var args = [];
            for(var _i = 2; _i < arguments.length; _i++){
                args[_i - 2] = arguments[_i];
            }
            if (_this.event) {
                _this.event.apply(_this, __spread([
                    new SystemEvent(level, message)
                ], args));
            }
        };
        this.info = logger.info || function(message) {
            var args = [];
            for(var _i = 1; _i < arguments.length; _i++){
                args[_i - 1] = arguments[_i];
            }
            return logAtLevel.apply(void 0, __spread([
                SystemEventLevel.INFO,
                message
            ], args));
        };
        this.warning = logger.warning || function(message) {
            var args = [];
            for(var _i = 1; _i < arguments.length; _i++){
                args[_i - 1] = arguments[_i];
            }
            return logAtLevel.apply(void 0, __spread([
                SystemEventLevel.WARN,
                message
            ], args));
        };
        this.error = logger.error || function(message) {
            var args = [];
            for(var _i = 1; _i < arguments.length; _i++){
                args[_i - 1] = arguments[_i];
            }
            return logAtLevel.apply(void 0, __spread([
                SystemEventLevel.ERROR,
                message
            ], args));
        };
    }
    return Logger2;
}();
// ../../../../node_modules/.pnpm/@shared-ui+logger-context@0.0.4_react@18.3.1/node_modules/@shared-ui/logger-context/dist/esmodule/logger-context.js
var defaults = new Logger({});
var LoggerContext = React.createContext(defaults);
var LoggerProvider = function LoggerProvider(props) {
    var logger = props.logger, children = props.children;
    var value = logger ? new Logger(logger) : defaults;
    return React.createElement(LoggerContext.Provider, {
        value: value
    }, children || null);
};
LoggerProvider.displayName = "LoggerProvider";
// ../internal/src/constants/constants.ts
var IDENTITY_COMMON_LOGGER_EVENTS = {
    IDENTITY_ATO_SCRIPT_ERROR: new SystemEvent(SystemEventLevel.ERROR, "IDENTITY_ATO_SCRIPT_ERROR")
};
// ../internal/src/constants/clickstream-constants.ts
var DEBOUNCE_TIME = 1e3;
// ../../../../node_modules/.pnpm/throttle-debounce@5.0.0/node_modules/throttle-debounce/esm/index.js
function throttle(delay, callback, options) {
    var _ref = options || {}, _ref$noTrailing = _ref.noTrailing, noTrailing = _ref$noTrailing === void 0 ? false : _ref$noTrailing, _ref$noLeading = _ref.noLeading, noLeading = _ref$noLeading === void 0 ? false : _ref$noLeading, _ref$debounceMode = _ref.debounceMode, debounceMode = _ref$debounceMode === void 0 ? void 0 : _ref$debounceMode;
    var timeoutID;
    var cancelled = false;
    var lastExec = 0;
    function clearExistingTimeout() {
        if (timeoutID) {
            clearTimeout(timeoutID);
        }
    }
    function cancel(options2) {
        var _ref2 = options2 || {}, _ref2$upcomingOnly = _ref2.upcomingOnly, upcomingOnly = _ref2$upcomingOnly === void 0 ? false : _ref2$upcomingOnly;
        clearExistingTimeout();
        cancelled = !upcomingOnly;
    }
    function wrapper() {
        for(var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++){
            arguments_[_key] = arguments[_key];
        }
        var self = this;
        var elapsed = Date.now() - lastExec;
        if (cancelled) {
            return;
        }
        function exec() {
            lastExec = Date.now();
            callback.apply(self, arguments_);
        }
        function clear() {
            timeoutID = void 0;
        }
        if (!noLeading && debounceMode && !timeoutID) {
            exec();
        }
        clearExistingTimeout();
        if (debounceMode === void 0 && elapsed > delay) {
            if (noLeading) {
                lastExec = Date.now();
                if (!noTrailing) {
                    timeoutID = setTimeout(debounceMode ? clear : exec, delay);
                }
            } else {
                exec();
            }
        } else if (noTrailing !== true) {
            timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === void 0 ? delay - elapsed : delay);
        }
    }
    wrapper.cancel = cancel;
    return wrapper;
}
function debounce(delay, callback, options) {
    var _ref = options || {}, _ref$atBegin = _ref.atBegin, atBegin = _ref$atBegin === void 0 ? false : _ref$atBegin;
    return throttle(delay, callback, {
        debounceMode: atBegin !== false
    });
}
// ../internal/src/utils/universal-profile-clickstream-utils/clickstream-utils.ts
var clickStreamEventBuilder = function(clickStreamEventConstants) {
    var _clickStreamEventConstants_event_data_event = clickStreamEventConstants.event_data.event, event_type = _clickStreamEventConstants_event_data_event.event_type, event_name = _clickStreamEventConstants_event_data_event.event_name, event_category = _clickStreamEventConstants_event_data_event.event_category, event_version = _clickStreamEventConstants_event_data_event.event_version, action_location = _clickStreamEventConstants_event_data_event.action_location, action_reason = _clickStreamEventConstants_event_data_event.action_reason, event_producer = _clickStreamEventConstants_event_data_event.event_producer;
    var _clickStreamEventConstants_event_data_experience = clickStreamEventConstants.event_data.experience, page_name = _clickStreamEventConstants_event_data_experience.page_name, page_name_detailed = _clickStreamEventConstants_event_data_experience.page_name_detailed;
    return {
        event: {
            event_type: event_type,
            event_name: event_name,
            event_category: event_category,
            event_version: event_version,
            action_location: action_location,
            event_producer: event_producer,
            action_reason: action_reason
        },
        experience: {
            page_name: page_name,
            page_name_detailed: page_name_detailed
        }
    };
};
var buildClickStreamEvent = function(clickStreamEventConstants) {
    var clickStreamEvent = clickStreamEventBuilder(clickStreamEventConstants);
    if ("additional_context" in clickStreamEventConstants.event_data) {
        clickStreamEvent.additional_context = clickStreamEventConstants.event_data.additional_context;
    }
    if ("form" in clickStreamEventConstants.event_data) {
        clickStreamEvent.form = clickStreamEventConstants.event_data.form;
    }
    if ("user" in clickStreamEventConstants.event_data) {
        clickStreamEvent.user = clickStreamEventConstants.event_data.user;
    }
    if ("error_list" in clickStreamEventConstants.event_data) {
        clickStreamEvent.error_list = clickStreamEventConstants.event_data.error_list;
    }
    return clickStreamEvent;
};
var searchEvent = function(payload, eventToSearch) {
    try {
        var eventsPayload = JSON.parse(payload);
        if (eventToSearch in eventsPayload.events) {
            return Object.values(eventsPayload.events[eventToSearch]).at(0);
        }
        return null;
    } catch (e) {
        return null;
    }
};
var searchObjectInArray = function(eventsList, eventToSearch) {
    var _eventsList_find;
    return (_eventsList_find = eventsList.find(function(event) {
        return event.eventName === eventToSearch;
    })) !== null && _eventsList_find !== void 0 ? _eventsList_find : null;
};
var searchFirstObjectInArray = function(eventsList, eventToSearch) {
    var _eventsList_find;
    return (_eventsList_find = eventsList.find(function(item) {
        return eventToSearch.includes(item.eventName);
    })) !== null && _eventsList_find !== void 0 ? _eventsList_find : null;
};
var searchEventInScheme = function(arrayEvent, eventToSearch) {
    if (arrayEvent) {
        var isArray = Array.isArray(eventToSearch);
        var eventObject = isArray ? searchFirstObjectInArray(arrayEvent, eventToSearch) : searchObjectInArray(arrayEvent, eventToSearch);
        if (eventObject === null || eventObject === void 0 ? void 0 : eventObject.payload) {
            var eventName = isArray ? eventObject.eventName : eventToSearch;
            var objectEvent = searchEvent(eventObject.payload, eventName);
            return objectEvent !== null && objectEvent !== void 0 ? objectEvent : null;
        }
    }
    return null;
};
var debounceTrackEvent = debounce(DEBOUNCE_TIME, function(trackEvent) {
    trackEvent();
});
// src/components/google-one-tap/utils/submit-action-utils.ts
import { gql as gql3 } from "@apollo/client";
// src/components/google-one-tap/__private/__fragments/identity-analytics-interaction-event.tsx
import { gql } from "@apollo/client";
var fragment = gql(_templateObject());
var IdentityAnalyticsInteractionEvent = {
    fragment: fragment
};
// src/components/google-one-tap/__private/__fragments/identity-analytics-outcome-event.tsx
import { gql as gql2 } from "@apollo/client";
var fragment2 = gql2(_templateObject1());
var IdentityAnalyticsOutcomeEvent = {
    fragment: fragment2
};
// src/components/google-one-tap/utils/submit-action-utils.ts
var __IdentityOneTapSubmitActionFragment = gql3(_templateObject2(), IdentityAnalyticsInteractionEvent.fragment, IdentityAnalyticsOutcomeEvent.fragment);
var getCsrfAtoInputs = function(atoActionCsrfData) {
    return {
        type: atoActionCsrfData === null || atoActionCsrfData === void 0 ? void 0 : atoActionCsrfData.type,
        inputs: [
            {
                key: atoActionCsrfData.inputKeys[0],
                value: atoActionCsrfData[atoActionCsrfData.inputKeys[0]]
            }
        ]
    };
};
// src/constants/google-script-constants.ts
var GOOGLE_SCRIPT_FLAG = "__googleOneTapScript__";
var GOOGLE_ONE_TAP_USER_CANCEL = "user_cancel";
var GOOGLE_ONE_TAP_OUTSIDE_CLICK = "tap_outside";
var GOOGLE_CLIENT_SCRIPT_URL = "https://accounts.google.com/gsi/client";
var SCRIPT_STATUS_IDLE = "idle";
var SCRIPT_STATUS_LOADING = "loading";
var SCRIPT_STATUS_READY = "ready";
var SCRIPT_STATUS_ERROR = "error";
var EVENT_TYPE_LOAD = "load";
var EVENT_TYPE_ERROR = "error";
// src/constants/google-one-tap-clickstream-constants.ts
var GOOGLE_ONE_TAP_DISPLAYED = "google_onetap.presented";
var GOOGLE_ONE_TAP_CLOSED = "google_onetap.closed";
var GOOGLE_ONE_TAP_HIDDEN = "google_onetap.hidden";
var GOOGLE_ONE_TAP_FAILED = "google_onetap.failed";
var GOOGLE_ONE_TAP_SUBMITTED = "google_onetap.submitted";
var GOOGLE_ONE_TAP_SUCCEEDED = "google_onetap.succeeded";
var GOOGLE_ONE_TAP_SIGN_IN_SUCCEEDED = "sign_in.succeeded";
var GOOGLE_ONE_TAP_SIGN_UP_SUCCEEDED = "sign_up.succeeded";
// src/hooks/mutations/use-google-one-tap-submit.tsx
import { useCallback } from "react";
import { gql as gql4, useMutation } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { useEgClickstream } from "@shared-ui/clickstream-analytics-context";
import { useExperiment } from "@shared-ui/experiment-context";
// src/components/google-one-tap/utils/post-google-one-tap-success.ts
var getAccountMergePageUrl = function(pageRedirectData) {
    var cmsToken = pageRedirectData.cmsToken, scenario = pageRedirectData.scenario, variant = pageRedirectData.variant, accountMergeSharedUiExposure = pageRedirectData.accountMergeSharedUiExposure;
    var currentPageRelativeUrl = "".concat(window.location.pathname).concat(window.location.search);
    var originUrl = encodeURIComponent(currentPageRelativeUrl);
    var isAccountMergeSharedUiEnabled = (accountMergeSharedUiExposure === null || accountMergeSharedUiExposure === void 0 ? void 0 : accountMergeSharedUiExposure.bucket) === 1;
    if (isAccountMergeSharedUiEnabled) {
        return "/accountmerge?redirectTo=".concat(originUrl, "&token=").concat(cmsToken, "&scenario=").concat(scenario, "&variant=").concat(variant);
    }
    return "/onboarding?originUrl=".concat(originUrl, "&cmsToken=").concat(cmsToken, "&scenario=").concat(scenario);
};
var getRegistrationFlowUrl = function(pageRedirectData) {
    var variant = pageRedirectData.variant, cmsToken = pageRedirectData.cmsToken, scenario = pageRedirectData.scenario, success = pageRedirectData.success;
    var currentPageRelativeUrl = "".concat(window.location.pathname).concat(window.location.search);
    var originUrl = encodeURIComponent(currentPageRelativeUrl);
    if (!success) {
        return "/login/error?redirectTo=".concat(originUrl, "&error=googleOneTap");
    }
    switch(variant){
        case "ONE_KEY" /* ONE_KEY_INTERSTITIAL */ :
        case "BETA_CONSENT_0" /* BETA_CONSENT_NEW_ACCOUNT */ :
        case "BETA_CONSENT_1" /* BETA_CONSENT_SINGLE_ACCOUNT */ :
        case "BETA_CONSENT_2" /* BETA_CONSENT_MULTI_ACCOUNT */ :
            return "/onboarding?originUrl=".concat(originUrl, "&cmsToken=").concat(cmsToken, "&scenario=").concat(scenario);
        case "ONE_IDENTITY_1" /* UPGRADE_MERGE_CONTINUE */ :
        case "ONE_IDENTITY_0" /* UPGRADE_MERGE_CREATE_PASSWORD */ :
        case "ONE_IDENTITY_2" /* UPGRADE_MERGE_SET_PASSWORD */ :
            return getAccountMergePageUrl(pageRedirectData);
        case "PASSWORD_1" /* CREATE_PASSWORD_WITH_MARKETING_CONSENT */ :
        case "PASSWORD_3" /* CREATE_PASSWORD_WITHOUT_MARKETING_CONSENT */ :
        case "PASSWORD_0" /* SET_PASSWORD_WITH_MARKETING_CONSENT */ :
        case "PASSWORD_2" /* SET_PASSWORD_WITHOUT_MARKETING_CONSENT */ :
            return "/addpassword?redirectTo=".concat(originUrl, "&token=").concat(cmsToken, "&scenario=").concat(scenario, "&variant=").concat(variant);
        case "PROFILE_DETAIL_0" /* ACCOUNT_INFO_WITH_MARKETING_CONSENT */ :
        case "PROFILE_DETAIL_1" /* ACCOUNT_INFO_WITHOUT_MARKETING_CONSENT */ :
            return "/accountinfo?redirectTo=".concat(originUrl, "&token=").concat(cmsToken, "&scenario=").concat(scenario, "&variant=").concat(variant);
        case "PROFILE_DETAIL_2" /* MARKETING_CONSENT */ :
            return "/marketingconsent?redirectTo=".concat(originUrl, "&token=").concat(cmsToken, "&scenario=").concat(scenario, "&variant=").concat(variant);
        case "ORIGIN" /* ORIGIN */ :
        default:
            return null;
    }
};
var postGoogleOneTapSuccessRedirect = function(pageRedirectData) {
    var redirectUrl = getRegistrationFlowUrl(pageRedirectData);
    if (redirectUrl === null) {
        window.location.reload();
    } else {
        window.location.assign(redirectUrl);
    }
};
// src/hooks/mutations/use-google-one-tap-submit.tsx
var __Mutation = gql4(_templateObject3(), IdentityAnalyticsOutcomeEvent.fragment);
var useGoogleOneTapSubmit = function() {
    var context = useBexApi().context;
    var _useExperiment = useExperiment("Onboarding_v2_Web"), accountMergeSharedUiExposure = _useExperiment.exposure;
    var _useMutation = _sliced_to_array(useMutation(__Mutation), 1), googleOneTapSubmit = _useMutation[0];
    var track = useEgClickstream();
    var authenticateWithGoogleOneTap = useCallback(function() {
        var _ref = _async_to_generator(function(googleAuthToken, action) {
            var _action_nonce, nonce, tmp, submitContext, _action_atoActions, atoActions, clickStreamAnalytics, csrfSubmitAction, atoInputs, _mutationResponse_googleOneTapSubmit, _ref, mutationResponse, _mutationResponse_googleOneTapSubmit1, analytics, variant, success, googleOneTapSuccessEventPayload, googleOneTapSignupSuccessEventPayload, googleOneTapSigninSuccessEventPayload, googleOneTapFailEventPayload, _e, googleOneTapFailEventPayload1;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _action_nonce = action.nonce, nonce = _action_nonce === void 0 ? "" : _action_nonce, tmp = action.context, submitContext = tmp === void 0 ? "" : tmp, _action_atoActions = action.atoActions, atoActions = _action_atoActions === void 0 ? [] : _action_atoActions, clickStreamAnalytics = action.clickStreamAnalytics;
                        csrfSubmitAction = (atoActions === null || atoActions === void 0 ? void 0 : atoActions.filter(function(atoAction) {
                            return atoAction.__typename === "IdentityCsrfWidgetAction";
                        })[0]) || {};
                        atoInputs = getCsrfAtoInputs(csrfSubmitAction);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            googleOneTapSubmit({
                                variables: {
                                    context: context,
                                    submitRequest: {
                                        context: submitContext,
                                        atoInputs: atoInputs,
                                        socialInput: {
                                            socialType: "GOOGLE" /* GOOGLE */ ,
                                            tokenType: "ID" /* ID */ ,
                                            token: googleAuthToken,
                                            nonce: nonce
                                        },
                                        input: []
                                    }
                                }
                            })
                        ];
                    case 2:
                        _ref = _state.sent(), mutationResponse = _ref.data;
                        if ((mutationResponse === null || mutationResponse === void 0 ? void 0 : (_mutationResponse_googleOneTapSubmit = mutationResponse.googleOneTapSubmit) === null || _mutationResponse_googleOneTapSubmit === void 0 ? void 0 : _mutationResponse_googleOneTapSubmit.__typename) === "IdentityGoogleOneTapMutationResponse") {
                            _mutationResponse_googleOneTapSubmit1 = mutationResponse.googleOneTapSubmit, analytics = _mutationResponse_googleOneTapSubmit1.analytics, variant = _mutationResponse_googleOneTapSubmit1.variant, success = _mutationResponse_googleOneTapSubmit1.success;
                            if (success) {
                                googleOneTapSuccessEventPayload = searchEventInScheme(analytics, GOOGLE_ONE_TAP_SUCCEEDED);
                                if (googleOneTapSuccessEventPayload) {
                                    track(buildClickStreamEvent(googleOneTapSuccessEventPayload));
                                }
                                googleOneTapSignupSuccessEventPayload = searchEventInScheme(analytics, GOOGLE_ONE_TAP_SIGN_UP_SUCCEEDED);
                                if (googleOneTapSignupSuccessEventPayload) {
                                    track(buildClickStreamEvent(googleOneTapSignupSuccessEventPayload));
                                }
                                googleOneTapSigninSuccessEventPayload = searchEventInScheme(analytics, GOOGLE_ONE_TAP_SIGN_IN_SUCCEEDED);
                                if (googleOneTapSigninSuccessEventPayload) {
                                    track(buildClickStreamEvent(googleOneTapSigninSuccessEventPayload));
                                }
                            } else {
                                googleOneTapFailEventPayload = searchEventInScheme(analytics, GOOGLE_ONE_TAP_FAILED);
                                if (googleOneTapFailEventPayload) {
                                    track(buildClickStreamEvent(googleOneTapFailEventPayload));
                                }
                            }
                            postGoogleOneTapSuccessRedirect(_object_spread_props(_object_spread({}, mutationResponse === null || mutationResponse === void 0 ? void 0 : mutationResponse.googleOneTapSubmit), {
                                accountMergeSharedUiExposure: accountMergeSharedUiExposure
                            }));
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        _e = _state.sent();
                        googleOneTapFailEventPayload1 = searchEventInScheme(clickStreamAnalytics, GOOGLE_ONE_TAP_FAILED);
                        if (googleOneTapFailEventPayload1) {
                            track(buildClickStreamEvent(googleOneTapFailEventPayload1));
                        }
                        postGoogleOneTapSuccessRedirect({
                            success: false
                        });
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(googleAuthToken, action) {
            return _ref.apply(this, arguments);
        };
    }(), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        context
    ]);
    return {
        authenticateWithGoogleOneTap: authenticateWithGoogleOneTap
    };
};
// src/hooks/google-one-tap-hooks/google-one-tap-login-hook.tsx
import { useEffect as useEffect2 } from "react";
import { useEgClickstream as useEgClickstream2 } from "@shared-ui/clickstream-analytics-context";
// src/hooks/google-one-tap-hooks/google-one-tap-script-hook.tsx
import { useEffect, useState } from "react";
var useScript = function(src) {
    var _useState = _sliced_to_array(useState(src ? SCRIPT_STATUS_LOADING : SCRIPT_STATUS_IDLE), 2), status = _useState[0], setStatus = _useState[1];
    useEffect(function() {
        if (!src) {
            setStatus(SCRIPT_STATUS_IDLE);
            return;
        }
        var script = document.querySelector('script[src="'.concat(src, '"]'));
        if (!script) {
            script = document.createElement("script");
            script.src = src;
            script.async = true;
            script.setAttribute("data-status", SCRIPT_STATUS_LOADING);
            document.body.appendChild(script);
            var setAttributeFromEvent = function(event) {
                if (script) {
                    script.setAttribute("data-status", event.type === EVENT_TYPE_LOAD ? SCRIPT_STATUS_READY : SCRIPT_STATUS_ERROR);
                }
            };
            script.addEventListener(EVENT_TYPE_LOAD, setAttributeFromEvent);
            script.addEventListener(EVENT_TYPE_ERROR, setAttributeFromEvent);
        } else {
            setStatus(script.getAttribute("data-status") || SCRIPT_STATUS_IDLE);
        }
        var setStateFromEvent = function(event) {
            setStatus(event.type === EVENT_TYPE_LOAD ? SCRIPT_STATUS_READY : SCRIPT_STATUS_ERROR);
        };
        script.addEventListener(EVENT_TYPE_LOAD, setStateFromEvent);
        script.addEventListener(EVENT_TYPE_ERROR, setStateFromEvent);
        return function() {
            if (script) {
                script.removeEventListener(EVENT_TYPE_LOAD, setStateFromEvent);
                script.removeEventListener(EVENT_TYPE_ERROR, setStateFromEvent);
            }
        };
    }, [
        src
    ]);
    return status;
};
// src/hooks/google-one-tap-hooks/google-one-tap-login-hook.tsx
var useGoogleOneTapLogin = function(param) {
    var disabled = param.disabled, googleAccountConfigs = param.googleAccountConfigs, _param_disableCancelOnUnmount = param.disableCancelOnUnmount, disableCancelOnUnmount = _param_disableCancelOnUnmount === void 0 ? false : _param_disableCancelOnUnmount, _param_initialize = param.initialize, initialize = _param_initialize === void 0 ? false : _param_initialize, analytics = param.analytics;
    var script = useScript(GOOGLE_CLIENT_SCRIPT_URL);
    var track = useEgClickstream2();
    useEffect2(function() {
        var _window, _window1;
        if (initialize && !((_window = window) === null || _window === void 0 ? void 0 : _window[GOOGLE_SCRIPT_FLAG]) && window.google && script === "ready") {
            var _window_google_accounts_id, _window_google_accounts, _window_google, _window2;
            (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window_google = _window2.google) === null || _window_google === void 0 ? void 0 : (_window_google_accounts = _window_google.accounts) === null || _window_google_accounts === void 0 ? void 0 : (_window_google_accounts_id = _window_google_accounts.id) === null || _window_google_accounts_id === void 0 ? void 0 : _window_google_accounts_id.initialize(_object_spread({}, googleAccountConfigs));
            window[GOOGLE_SCRIPT_FLAG] = true;
        }
        if (initialize && ((_window1 = window) === null || _window1 === void 0 ? void 0 : _window1[GOOGLE_SCRIPT_FLAG]) && window.google && script === "ready" && !disabled) {
            var _window_google_accounts_id1, _window_google_accounts1, _window_google1, _window3;
            (_window3 = window) === null || _window3 === void 0 ? void 0 : (_window_google1 = _window3.google) === null || _window_google1 === void 0 ? void 0 : (_window_google_accounts1 = _window_google1.accounts) === null || _window_google_accounts1 === void 0 ? void 0 : (_window_google_accounts_id1 = _window_google_accounts1.id) === null || _window_google_accounts_id1 === void 0 ? void 0 : _window_google_accounts_id1.prompt(function(notification) {
                if (GOOGLE_ONE_TAP_USER_CANCEL === (notification === null || notification === void 0 ? void 0 : notification.getSkippedReason())) {
                    var googleOneTapCloseEventPayload = searchEventInScheme(analytics, GOOGLE_ONE_TAP_CLOSED);
                    if (googleOneTapCloseEventPayload) {
                        track(buildClickStreamEvent(googleOneTapCloseEventPayload));
                    }
                }
                if (GOOGLE_ONE_TAP_OUTSIDE_CLICK === (notification === null || notification === void 0 ? void 0 : notification.getSkippedReason())) {
                    var googleOneTapHiddenEventPayload = searchEventInScheme(analytics, GOOGLE_ONE_TAP_HIDDEN);
                    if (googleOneTapHiddenEventPayload) {
                        track(buildClickStreamEvent(googleOneTapHiddenEventPayload));
                    }
                }
                if (notification === null || notification === void 0 ? void 0 : notification.isDisplayed()) {
                    var googleOneTapDisplayEventPayload = searchEventInScheme(analytics, GOOGLE_ONE_TAP_DISPLAYED);
                    if (googleOneTapDisplayEventPayload) {
                        track(buildClickStreamEvent(googleOneTapDisplayEventPayload));
                    }
                }
            });
            return function() {
                if (!disableCancelOnUnmount) {
                    var _window_google_accounts_id, _window_google_accounts, _window_google, _window;
                    (_window = window) === null || _window === void 0 ? void 0 : (_window_google = _window.google) === null || _window_google === void 0 ? void 0 : (_window_google_accounts = _window_google.accounts) === null || _window_google_accounts === void 0 ? void 0 : (_window_google_accounts_id = _window_google_accounts.id) === null || _window_google_accounts_id === void 0 ? void 0 : _window_google_accounts_id.cancel();
                }
            };
        }
    }, [
        script,
        initialize,
        disabled,
        disableCancelOnUnmount
    ]);
    return null;
};
// src/components/google-one-tap/__private/__fragments/google-one-tap-login.tsx
function GoogleOneTapLogin(_param) {
    var _param_children = _param.children, children = _param_children === void 0 ? null : _param_children, props = _object_without_properties(_param, [
        "children"
    ]);
    useGoogleOneTapLogin(props);
    return children;
}
// src/components/google-one-tap/__private/__fragments/identity-analytics-impression-event.tsx
import { gql as gql5 } from "@apollo/client";
var fragment3 = gql5(_templateObject4());
var IdentityAnalyticsImpressionEvent = {
    fragment: fragment3
};
// src/components/google-one-tap/__private/__fragments/identity-google-one-tap-response.tsx
var fragment4 = gql6(_templateObject5(), IdentityAnalyticsImpressionEvent.fragment, IdentityAnalyticsInteractionEvent.fragment, __IdentityOneTapSubmitActionFragment);
var IdentityGoogleOneTapResponse = function(param) {
    var data = param.data;
    var configuration = data.configuration, analytics = data.analytics, action = data.action, allowIntelligentTrackingPrevention = data.allowIntelligentTrackingPrevention;
    var clientId = (configuration === null || configuration === void 0 ? void 0 : configuration.clientId) || "";
    var itp_support = allowIntelligentTrackingPrevention || false;
    var _useState2 = _sliced_to_array(useState2(false), 2), initializeOneTap = _useState2[0], setInitializeOneTap = _useState2[1];
    useEffect3(function() {
        if (typeof window !== "undefined") {
            setInitializeOneTap(true);
        }
    }, []);
    var track = useEgClickstream3();
    var authenticateWithGoogleOneTap = useGoogleOneTapSubmit().authenticateWithGoogleOneTap;
    var googleOneTapCallback = function() {
        var _ref = _async_to_generator(function(response) {
            var googleOneTapSubmitEventPayload, googleOneTapFailEventPayload;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        googleOneTapSubmitEventPayload = searchEventInScheme(action === null || action === void 0 ? void 0 : action.clickStreamAnalytics, GOOGLE_ONE_TAP_SUBMITTED);
                        if (googleOneTapSubmitEventPayload) {
                            track(buildClickStreamEvent(googleOneTapSubmitEventPayload));
                        }
                        if (!(response === null || response === void 0 ? void 0 : response.credential)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            authenticateWithGoogleOneTap(response.credential, action)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        googleOneTapFailEventPayload = searchEventInScheme(action === null || action === void 0 ? void 0 : action.clickStreamAnalytics, GOOGLE_ONE_TAP_FAILED);
                        if (googleOneTapFailEventPayload) {
                            track(buildClickStreamEvent(googleOneTapFailEventPayload));
                        }
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function googleOneTapCallback(response) {
            return _ref.apply(this, arguments);
        };
    }();
    return /* @__PURE__ */ React2.createElement(GoogleOneTapLogin, {
        googleAccountConfigs: {
            client_id: clientId,
            callback: googleOneTapCallback,
            nonce: action === null || action === void 0 ? void 0 : action.nonce,
            itp_support: itp_support,
            use_fedcm_for_prompt: false
        },
        initialize: initializeOneTap,
        analytics: analytics
    });
};
IdentityGoogleOneTapResponse.fragment = fragment4;
IdentityGoogleOneTapResponse.displayName = "IdentityGoogleOneTapResponse";
// src/components/google-one-tap/__private/__fragments/google-one-tap-query-component.tsx
var __Query = gql7(_templateObject6(), IdentityGoogleOneTapResponse.fragment);
var GoogleOneTapQueryComponent = function(param) {
    var skipSsr = param.skipSsr;
    var _data_googleOneTap;
    var context = useBexApi2().context;
    var variables = {
        context: context
    };
    var _useQuery = useQuery(__Query, {
        context: context,
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    if (loading || error || !data || typeof window === "undefined") {
        return null;
    }
    switch((_data_googleOneTap = data.googleOneTap) === null || _data_googleOneTap === void 0 ? void 0 : _data_googleOneTap.__typename){
        case "IdentityGoogleOneTapResponse":
            return /* @__PURE__ */ React3.createElement(IdentityGoogleOneTapResponse, {
                data: data.googleOneTap
            });
        default:
            return null;
    }
};
GoogleOneTapQueryComponent.displayName = "sharedui-GoogleOneTapQueryComponent";
// src/components/google-one-tap/google-one-tap.tsx
var GoogleOneTap = function(param) {
    var skipSsr = param.skipSsr;
    var _context_identity;
    var context = useBexApi3().context;
    if ((context === null || context === void 0 ? void 0 : (_context_identity = context.identity) === null || _context_identity === void 0 ? void 0 : _context_identity.authState) === "AUTHENTICATED" /* AUTHENTICATED */ ) {
        return null;
    }
    return /* @__PURE__ */ React4.createElement(GoogleOneTapQueryComponent, {
        skipSsr: skipSsr
    });
};
GoogleOneTap.displayName = "sharedui-GoogleOneTap";
export { GoogleOneTap };
//# sourceMappingURL=index.js.map